import { useState, useEffect, useRef } from "react";
import { Popup } from "../../popup";
import { MyNotificationsPopUpWrapper } from "./styles";
import { Button } from "../../common/ui/widgets";
import { useDispatch, useSelector } from "react-redux";
import { userConstants } from "../../user/Constants";
import disableReadIcon from "./icons/read-icon.svg";
import enableReadIcon from "./icons/mark-read-icon.svg";
import disableDeletecon from "./icons/Delete-disable-icon.svg";
import enableDeletecon from "./icons/Delete-enable-icon.svg";
import { userNotificationsActions } from "./Actions";
import NotificationTile from "./notificationTile";
import ajaxLoader from "../../common/icons/ajax-loader.gif";
import {
  DURATION_MILLISECOND_LIST,
  FILTER_LIST,
} from "./notificationTile/constants";
import { useTranslation } from "react-i18next";

const MyNotificationsPopUp = () => {
  const { t } = useTranslation();
  const { user, showMyNotificationsPopUp } = useSelector(
    (state) => state.login
  );
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    (Array.isArray(user) && user[0]) ||
    (user && user.userAccountId ? user : null) ||
    {};
  const userId = currentUser?.userAccountId ?? null;
  const dispatch = useDispatch();

  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const loader = useRef(null);
  const [isSuccess, setIsSuccess] = useState(true);

  const toggleUncheck = () => {
    setIsSuccess((isSuccess) => !isSuccess);
  };

  const [notificationsList, setNotificationsList] = useState([]);

  const getUpdatedUserNotifications = async (countval, offsetVal) => {
    let params = {
      userId: userId,
      offset: offsetVal,
      count: countval,
      notifType: filter,
      ifModifiedSince: duration === "All" ? "" : modifiedSince,
    };

    const notifications = await userNotificationsActions
      .getUserNotifications(params)
      .then((response) => {
        if (response.status === "OK") {
          return response.notification;
        }
      })
      .catch((error) => console.error("error is", error));
    if (notifications) {
      setNotificationsList(notifications);
    }
  };

  const noSideBarRef = useRef();
  const handleNotificationScroll = () => {
    const noSideBar = noSideBarRef.current;

    if (!loading) {
      let scrollBound = noSideBar.scrollHeight * 0.65;
      let totalHeight = window.innerHeight + noSideBar.scrollTop;

      if (
        noSideBar.scrollTop > scrollBound ||
        totalHeight === noSideBar.scrollHeight
      ) {
        if (offset <= notificationCount) {
          setLoading(true);

          setOffset((offset) => offset + 10);
        }
      }
    }
  };

  const closeMyNotificationsPopUp = () => {
    dispatch({
      type: userConstants.SHOW_MY_NOTIFICATIONS_POPUP,
      showMyNotificationsPopUp: false,
    });
  };

  const [filter, setFilter] = useState("All");
  const [duration, setDuration] = useState("All");
  const [notifType, setNotifType] = useState("all");
  const [modifiedSince, setModifiedSince] = useState("");
  const [togglefilter, setToggleFilter] = useState(false);
  const [toggleduration, setToggleDuration] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [notificationsIds, setNotificationsIds] = useState([]);

  const handleAddData = (notificationId) => {
    setNotificationsIds((prevArray) => [...prevArray, notificationId]);
  };

  const handleRemoveData = (notificationId) => {
    setNotificationsIds(
      notificationsIds.filter((item) => item !== notificationId)
    );
  };

  const fetchUpdatedNotificationsList = () => {
    getUpdatedUserNotifications(notificationsList.length, 0);
  };

  const postBulkMarkReadNotifications = () => {
    var doBulkRead = window.confirm(
      "Are you sure you want to mark read all selected notifications?" +
        "\n" +
        "This action cannot be undone."
    );
    if (doBulkRead) {
      let params = {
        selectAll: selectAllChecked,
        ids: notificationsIds,
        userAccountId: userId,
        sessionId: "",
      };
      userNotificationsActions
        .postBulkMarkReadNotification(params)
        .then((response) => {
          toggleUncheck();
          setSelectAllChecked(false);
          setNotificationsIds([]);
          fetchUpdatedNotificationsList();
        });
    }
  };

  const deleteBulkMarkDeleteNotifications = () => {
    var doBulkDelete = window.confirm(
      "Are you sure you want to delete all selected notifications?" +
        "\n" +
        "This action cannot be undone."
    );
    if (doBulkDelete) {
      let params = {
        selectAll: selectAllChecked,
        ids: notificationsIds,
        userAccountId: userId,
        sessionId: "",
      };
      userNotificationsActions
        .deleteBulkMarkDeleteNotification(params)
        .then((response) => {
          toggleUncheck();
          setSelectAllChecked(false);
          setNotificationsIds([]);
          fetchUpdatedNotificationsList();
        });
    }
  };

  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      return;
    }

    const getUserNotifications = async () => {
      setLoading(true);
      let params = {
        userId: userId,
        offset: offset,
        count: 10,
        notifType: notifType,
        ifModifiedSince: duration === "All" ? "" : modifiedSince,
      };
    
      try {
        const response = await userNotificationsActions.getUserNotifications(params);
        if (response?.status === "OK") {
          setNotificationCount(response.count);
          const notifications = response.notification || []; 

          if (notifications.length > 0) {
            if (offset <= response.count) {
              setNotificationsList((prevList) => [...prevList, ...notifications]);
            } else {
              setLoading(false);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
      setLoading(false);
    };
    getUserNotifications();
  }, [offset, filter, modifiedSince, userId]);

  return (
    <>
      {showMyNotificationsPopUp && (
        <Popup closePopup={closeMyNotificationsPopUp}>
          <MyNotificationsPopUpWrapper>
            <div className="my-notification-header">
              <div>
                {t("My Notifications")}
              </div>
              <div
                className="close-activation-popup-button"
                onClick={closeMyNotificationsPopUp}
              >
                ×
              </div>
            </div>
            <div className="sub-header">
              <div className="select-input">
                <input
                  onChange={() => setSelectAllChecked(!selectAllChecked)}
                  type="checkbox"
                  checked={selectAllChecked}
                />
                <label>
                  {t("Select All")}
                </label>
              </div>
              <div
                onMouseEnter={() => setToggleDuration(true)}
                onMouseLeave={() => setToggleDuration(false)}
                className="duration dropdown"
              >
                <span>
                  {t("Duration")}:
                </span>
                <span className="filter-duration">
                  {t(duration)}
                </span>
                {toggleduration && (
                  <div className="drop-down">
                    <ul>
                      {DURATION_MILLISECOND_LIST.map((i) => (
                        <li
                          key={i.value}
                          onClick={() => {
                            setModifiedSince(Date.now() - i.value);
                            setDuration(i.label);
                            setOffset(0);
                            setNotificationsList([]);
                          }}
                        >
                          {t(i.label)}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div
                onMouseEnter={() => setToggleFilter(true)}
                onMouseLeave={() => setToggleFilter(false)}
                className="filter dropdown"
              >
                <span>
                  {t("Filter")}:
                </span>
                <span className="filter-type">
                  {" "}
                  {t(filter)}
                </span>
                {togglefilter && (
                  <div className="drop-down">
                    <ul>
                      {FILTER_LIST.map((i) => (
                        <li
                          key={i.value}
                          onClick={() => {
                            setNotifType(i.value);
                            setFilter(i.label);
                            setOffset(0);
                            setNotificationsList([]);
                          }}
                        >
                          {t(i.label)}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="read-delete-icons">
                <div
                  onClick={() => {
                    if (selectAllChecked || notificationsIds.length > 0) {
                      postBulkMarkReadNotifications();
                    }
                  }}
                >
                  <img
                    src={
                      selectAllChecked || notificationsIds.length > 0
                        ? enableReadIcon
                        : disableReadIcon
                    }
                    alt="readIcon"
                  />
                </div>
                <div className="seperator"></div>
                <div
                  onClick={() => {
                    if (selectAllChecked || notificationsIds.length > 0) {
                      deleteBulkMarkDeleteNotifications();
                    }
                  }}
                >
                  <img
                    src={
                      selectAllChecked || notificationsIds.length > 0
                        ? enableDeletecon
                        : disableDeletecon
                    }
                    alt="deleteIcon"
                  />
                </div>
              </div>
            </div>
            <section
              className="notifications-list"
              ref={noSideBarRef}
              onScroll={handleNotificationScroll}
            >
              {!loading && notificationsList.length === 0 && (
                <p>
                  {t("No notification available")}
                </p>
              )}

              {notificationsList
                .sort((a, b) => b.createdDate - a.createdDate)
                .map((element) => (
                  <NotificationTile
                    key={element.notificationId}
                    data={element}
                    addNotification={handleAddData}
                    removeNotification={handleRemoveData}
                    selectAll={selectAllChecked}
                    isSuccess={isSuccess}
                    setIsSuccess={setIsSuccess}
                    toggleUncheck={toggleUncheck}
                    notificationsIds={notificationsIds}
                    closePopup={closeMyNotificationsPopUp}
                  />
                ))}
              <div ref={loader} />
            </section>
            {loading && (
              <div className="loader">
                <img src={ajaxLoader} alt="loading..." loading="lazy" width="32" height="32" />
              </div>
            )}

            <div className="pop-footer-btn">
              <Button handleOnClick={closeMyNotificationsPopUp}>
                {t("CLOSE")}
              </Button>
            </div>
          </MyNotificationsPopUpWrapper>
        </Popup>
      )}
    </>
  );
};

export default MyNotificationsPopUp;
